import React, { useState, useEffect } from 'react';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import { toast } from 'react-toastify';
import { getTranslateByKey } from '@/main/services/utils';
import * as S from './styles';
import { copyToClipboardText } from '@/main/services/utilsString';

interface ICopyToClipboardText {
  valueToCopy: string;
  label: string;
  hideIcon?: boolean;
  children: React.ReactNode;
  maxWidth?: string;
}
function CopyToClipboardText({
  valueToCopy,
  label,
  hideIcon = false,
  children,
  maxWidth = "160px"
}: ICopyToClipboardText) {
  const [open, setOpen] = useState(false);

  function copyValueText() {
    copyToClipboardText(valueToCopy);
    setOpen(true);
  }

  useEffect(() => {
    if (open) {
      toast.success(getTranslateByKey('information.copySuccess'));
      setOpen(false);
    }
  }, [open]);

  return (
    <>
      <S.TextToCopy $maxWidth={maxWidth} className='kog-area-textToCopy' title={valueToCopy} onClick={copyValueText}>
        {children}
        {children && !hideIcon && (
          <FileCopyOutlinedIcon
            fontSize="small"
            titleAccess={`${getTranslateByKey('information.copy')} ${label}`}
          />
        )}
      </S.TextToCopy>
    </>
  );
}

export default CopyToClipboardText;
